export interface Publisher {
  publisherId: string
  slug: string
  displayName: string
  gameCount: number
  ownerIds: string | null
}

export interface Game {
  gameId: string
  gameSlug: string
  publisherSlug: string
  publisherDisplayName: string
  displayName: string
  versionCount: number
}

export interface Project {
  projectId: string
  telemetryProjectId: string | null
  gameId: string | null
  versionCount: number | null
  lastActive: string | null
  publisherSlug: string | null
  gameSlug: string | null
  displayName: string | null
  lastPublished: string | null
  ownerName: string | null
}

export interface TelemetryEvent {
  id: number
  event_type: string
  project_id: string | null
  folder_id: string | null
  timestamp: string
  agent: string | null
  git_user: string | null
  os_info: string | null
  metadata: string | null
  created_at: string
}

export function formatRelativeTime(dateStr: string): string {
  const date = new Date(dateStr)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  
  if (isNaN(diffMs)) return 'N/A'
  
  const diffSecs = Math.floor(diffMs / 1000)
  if (diffSecs < 60) return 'Just now'
  
  const diffMins = Math.floor(diffSecs / 60)
  if (diffMins < 60) return `${diffMins}m ago`
  
  const diffHours = Math.floor(diffMins / 60)
  if (diffHours < 24) return `${diffHours}h ago`
  
  const diffDays = Math.floor(diffHours / 24)
  if (diffDays < 30) return `${diffDays}d ago`
  
  const diffMonths = Math.floor(diffDays / 30)
  if (diffMonths < 12) return `${diffMonths}mo ago`
  
  const diffYears = Math.floor(diffMonths / 12)
  return `${diffYears}y ago`
}
